'use strict';

import { createAction } from 'redux-actions';

/**
 * Here we will have a list of all of the actions available in the application.
 * Make sure to document the action and keep this convetion:
 *
 * For application state:
 * APP_{FEATURE}_{ACTION}
 *
 * For objects and data:
 * {OBJECT_OR_MODEL}_{ACTION}
 *
 * Keep the actions in alphabetical order.
 *
**/

///////////////
// CONSTANTS //
///////////////
/** @constant */
export const DB_FETCH_REQUEST = 'DB_FETCH_REQUEST';
/** @constant */
export const DB_FETCH_SUCCESS = 'DB_FETCH_SUCCESS';
/** @constant */
export const DB_FETCH_FAILURE = 'DB_FETCH_FAILURE';
/** @constant */
export const DB_FETCH = 'DB_FETCH';

/////////////
// ACTIONS //
/////////////
export const dbFetchRequest = createAction(DB_FETCH_REQUEST);
export const dbFetchFailure = createAction(DB_FETCH_FAILURE);
export const dbFetchSuccess = createAction(DB_FETCH_SUCCESS);

export const dbFetch = createAction(DB_FETCH, (graphql, schema, fetchType, isAuthAPI, authApiName, shouldCallAPI) => {
  return {
    remote: true,
    requestTypes: [DB_FETCH_REQUEST, DB_FETCH_SUCCESS, DB_FETCH_FAILURE],
    shouldCallAPI,
    graphql,
    schema,
    fetchType: !!fetchType ? fetchType : 'post',
    isAuthAPI: !!isAuthAPI ? isAuthAPI : false,
    authApiName: !!authApiName ? authApiName : null
  };
});



// WEBPACK FOOTER //
// ./src/store/actions.js